export default {
  Coupon: "Coupon",
  AddCoupon: "AddCoupon",
  editCoupon: "EditCoupon",
};
